export enum StatisticsResourceStatus {
    scheduled = 'SCHEDULED',
    sent = 'SENT',
    pending = 'PENDING'
}
